import mail from "../assets_djole/mail.png";
import mobile from "../assets_djole/mobile.png";
import api from "../assets_djole/api.png";
import css from "../assets_djole/css.png";
import figma from "../assets_djole/figma.png";
import git from "../assets_djole/git.png";
import html from "../assets_djole/html.png";
import javascript from "../assets_djole/javascript.png";
import react from "../assets_djole/react.png";
import redux from "../assets_djole/redux.png";
import sass from "../assets_djole/sass.png";
import csharp from "../assets_djole/csharp.png";

import about01 from "../assets_djole/about01.png";
import about02 from "../assets_djole/about02.png";
import about03 from "../assets_djole/about03.png";

import profile from "../assets_djole/profilna.png";
import circle from "../assets_djole/circle.svg";
import logo from "../assets_djole/logoo.png";

import bolt from "../assets_djole/bolt.png";
import nb from "../assets_djole/nb.png";

export default {
  mail,
  mobile,
  api,
  css,
  figma,
  git,
  html,
  javascript,
  react,
  redux,
  sass,
  csharp,
  about01,
  about02,
  about03,
  profile,
  circle,
  logo,
  bolt,
  nb,
};
